import { eventEmitter } from '@/hooks/useSagaNavigator';
import { NavigateOptions, To } from 'react-router-dom';

export const sagaNavigator = (path: To, options?: NavigateOptions) => {
  eventEmitter.emit('navigate', { path, options });
};
